module.exports = new __parcel__URL__("LiSl.56ae123e.png").toString();